import { useCallback, useMemo } from "react"
import styled from "styled-components"

type Props = {
    response: {
        ok: boolean,
        message?: string,
    }
}

const message: { [name: string]: JSX.Element } = {
    "full-occupied": (
        <p>
            満席のため、ご入力いただいた人数では予約できません。
        </p>
    ),
    "seat-has-occupied": (
        <>
            <p>
                ご指定の座席は、入れ違いで他のお客様の予約が入りました。
            </p>
            <p>
                お手数ですが、もう一度他の座席のご予約をお試しください。
            </p>
        </>
    ),
    "update failed": (
        <>
            <p>
                処理中にエラーが発生しました。
            </p>
            <p>
                お手数ですが、もう一度お試しください。
            </p>
        </>
    )
}

const Complete = (props: Props) => {
    const ResultIcon = useCallback((title: string) => {
        return (
            <ResultIconStyle>
                <div className="check">✔</div>
                <div className="icon-body">
                    {title}
                </div>
                <div className="icon-shadow"></div>
            </ResultIconStyle>
        )
    }, [])

    const validComponent = useMemo(() => {
        return (
            <>  
                {ResultIcon("Reservation Completed")}
                <div className="title">予約いただきありがとうございます！</div>
                <div className="messages">
                    <div>
                        予約確定メールを送信いたしました。
                    </div>
                    <div>（内容は当サイトのマイページからも確認いただけます）</div>
                    <div>
                        当日のお越しをお待ちしております。
                    </div>
                </div>
            </>
        )
    }, [ResultIcon])

    const invalidComponent = useMemo(() => {
        const unknownMessage = <div>お手数ですが、もう一度お試しください。</div>
        
        return (
            <>
                <div className="title">予約できませんでした</div>
                <div className="messages">
                    {props.response.message ? message[props.response.message] : unknownMessage || unknownMessage}
                </div>
            </>
        )
    }, [props.response.message])

    const components = useMemo(() => {
        return (<CompleteStyle>
            { props.response.ok ? validComponent : invalidComponent }
        </CompleteStyle>)
    }, [invalidComponent, props.response.ok, validComponent])

    return components
}

const CompleteStyle = styled.div`
    color: white;
    margin: auto;
    .title {
        margin: 20px auto 20px auto;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
    }
    .messages {
        width: 300px;
        text-align: center;
        margin: auto;
    }
`

const ResultIconStyle = styled.div`
    width: 320px;
    position: relative;
    margin: 20px auto 20px auto;
    .check {
        position: absolute;
        top: -35px;
        left: 15px;
        z-index: 2;
        font-size: 60px;
    }
    .icon-body {
        z-index: 1;
        position: relative;
        font-size: 20px;
        font-style: italic;
        font-family: 'Times New Roman', Times, serif;
        font-weight: bold;
        background-color: red;
        width: 320px;
        height: 40px;
        display: flex;
        align-items: center;
        text-align: left;
        justify-content: left;
        padding: 0 60px 0 60px;
        clip-path: polygon(0% 100%, 10% 0%, 100% 0%, 90% 100%);
    }
    .icon-shadow {
        z-index: 0;
        position: absolute;
        top: 10px;
        left: 5px;
        background-color: white;
        width: 320px;
        height: 40px;
        display: flex;
        align-items: center;
        text-align: left;
        justify-content: left;
        padding: 0 60px 0 60px;
        clip-path: polygon(0% 100%, 10% 0%, 100% 0%, 90% 100%);
    }
`

export default Complete